import { useState } from "react";
import { useEvent } from "../../../context/EventContext";
import Calender from "./subEvent/Calender";
import SubEventForm from "./subEvent/subEventForm";
import SubEventFormPreview from "./subEvent/subEventFormPreview";

//  * SubEvent is a component that displays a calendar, a form to add sub-events and a preview of the sub-events
//  * added. It is used in the organizer dashboard to add sub-events to the main event.
const SubEvent = ({ onNext }) => {
  const { subEventAdded, subEventFormData, subEvents } = useEvent();
  const [isFormVisible, setIsFormVisible] = useState(false);

//   console.log(subEvents);

  return (
    <div className="subEvent-section">
      {subEvents && (
        <Calender
          subEventFormData={subEventFormData} // Pass subEventFormData to the calendar
          subEvents={subEvents}
          setIsFormVisible={setIsFormVisible}
          isFormVisible={isFormVisible}
        />
      )}

      {isFormVisible && <SubEventForm setIsFormVisible={setIsFormVisible} />}

      {/* Show preview section if subEvent has been added and form is not visible */}
      {!isFormVisible && subEventAdded && (
        <SubEventFormPreview
          onNext={onNext}
          setIsFormVisible={setIsFormVisible}
        />
      )}
    </div>
  );
};

export default SubEvent;
